export default __webpack_public_path__ + "static/media/responsible.a7bc4431.svg";